// Vendors
import $ from 'jquery';

/**
 * Header search reveal.
 *
 * Turns a normal WordPress menu item (given the CSS class `top-menu-search`)
 * into a search trigger. Clicking it reveals a dropdown panel containing the
 * shared `.search-autosuggest` field, which the autosuggest module powers
 * automatically because its markup is already in the DOM at load.
 *
 * The panel is positioned with `position: fixed`, anchored under the trigger,
 * so it works no matter which menu the client places the item in.
 */
const TRIGGER = '.top-menu-search';
const PANEL = '.header-search';
const OPEN_CLASS = 'header-search--open';

const $trigger = $(TRIGGER);
const $panel = $(PANEL);

if ($trigger.length && $panel.length) {
  const $link = $trigger.children('a').first();
  const $input = $panel.find('.search-autosuggest__input');

  // Replace the menu label with an icon; expose the name via aria-label
  $link.html('<span class="fa fa-search" aria-hidden="true"></span>');
  $link.attr({ 'aria-label': 'Search', 'aria-expanded': 'false' });

  function position() {
    const el = $link[0] || $trigger[0];
    const rect = el.getBoundingClientRect();

    $panel.css({
      top: `${Math.round(rect.bottom + 8)}px`,
      right: `${Math.round(Math.max(window.innerWidth - rect.right, 8))}px`
    });
  }

  function open() {
    position();
    $panel.addClass(OPEN_CLASS);
    $link.attr('aria-expanded', 'true');
    window.setTimeout(() => $input.trigger('focus'), 0);
  }

  function close() {
    $panel.removeClass(OPEN_CLASS);
    $link.attr('aria-expanded', 'false');
  }

  $link.on('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    if ($panel.hasClass(OPEN_CLASS)) {
      close();
    } else {
      open();
    }
  });

  // Keep clicks inside the panel from bubbling to the document close handler
  $panel.on('click', (event) => event.stopPropagation());

  // Close on outside click and on Escape
  $('html').on('click', close);
  $(document).on('keydown', (event) => {
    if (event.keyCode === 27) {
      close();
    }
  });

  // Keep the panel anchored to the trigger as the layout shifts
  $(window).on('resize', () => {
    if ($panel.hasClass(OPEN_CLASS)) {
      position();
    }
  });
  $(window).on('scroll', close);
}
